<script>
import Layout from "../../layouts/auth";
import { authMethods } from "@/state/helpers";
import appConfig from "@/app.config";
import {env} from "@/state/helpers";

import { required, email } from "vuelidate/lib/validators";
import axios from "axios";
import ErrorAlert from "@/components/errorAlert";
import { toast, variants } from "@/helpers/toaster";

/**
 * Forgot Password component
 */
export default {
  page: {
    title: "Inicijalna/zaboravljena lozinka",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {ErrorAlert, Layout },
  data() {
    return {
      email: "",
      submitted: false,
      error: null,
      tryingToReset: false,
      isResetError: false,
      isEmailSent: false,
      // sitekey: '',
      // validaRecaptcha: false,
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.loader.loading;
    },
  },
  validations: {
    email: { required, email }
  },
  created() {
    // this.sitekey = env('VUE_APP_RECAPTCHA_SITEKEY');
  },
  mounted() {
    // window.expireRecaptcha = () => {
    //   this.validRecaptcha = false;
    // };
    // if (window.grecaptcha) {
    //   this.rcapt_id = grecaptcha.render('g-recaptcha', { sitekey : this.sitekey});
    // }
  },
  methods: {
    ...authMethods,
    async tryToReset() {
      this.$store.commit('errorBag/CLEAR');

      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      // const g_recaptcha_response = grecaptcha.getResponse(this.rcapt_id);
      // if (g_recaptcha_response.length == 0) {
      //   toast("Popunite Recaptcha verifikaciju.", variants.WARNING);
      //   return false;
      // } else if (!this.validRecaptcha) {
      //   const response = await axios.post('/tokens/verify-recaptcha', {
      //     token: g_recaptcha_response,
      //     expected_action: "LOGIN"
      //   });
      //   if (response.status !== 200) {
      //     toast("Neuspešna Recaptcha verifikacija.", variants.ERROR);
      //     return false;
      //   }
      //   this.validRecaptcha = true;
      // }

      if (this.$v.$invalid) {
        return;
      } else {
        try {
          this.$store.commit('loader/START_LOADING');

          await axios.post('/sendPasswordResetLink', {
            email: this.email
          })
          this.isEmailSent = true;
        } catch (error) {
          // eslint-disable-next-line no-empty
        } finally {
          this.$store.commit('loader/END_LOADING');
        }
      }
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <error-alert></error-alert>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">

            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Inicijalna/zaboravljena lozinka</h5>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-white">
                    <img src="@/assets/images/logo/influcent-icon-blue.png" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>
            <div v-if="isEmailSent" class="p-2">
              Email poruka je poslata na adresi: <i>{{ email }}</i>. U poruci se nalazi link za izmenu lozinke.
            </div>
            <div v-else class="p-2">
              <b-alert v-model="isResetError" class="mb-4" variant="danger" dismissible>{{error}}</b-alert>
              <form @submit.prevent="tryToReset">
                <div class="form-group">
                  <label for="useremail">Email</label>
                  <input
                    type="email"
                    v-model="email"
                    class="form-control"
                    id="useremail"
                    :disabled="isLoading"
                    :class="{ 'is-invalid': submitted && $v.email.$error }"
                  />
                  <div v-if="submitted && $v.email.$error" class="invalid-feedback">
                    <span v-if="!$v.email.required">Unesi email.</span>
                    <span v-if="!$v.email.email">Unesi validan email.</span>
                  </div>
                </div>

                <!-- <div id="g-recaptcha" class="g-recaptcha" :data-sitekey="sitekey" :data-expired-callback="expireRecaptcha"></div> -->

                <div class="form-group row mb-0">
                  <div class="col-12 text-right">
                    <button class="btn btn-primary w-md" type="submit">Pošalji</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            <router-link tag="a" to="/login" class="font-weight-medium text-primary">Nazad na prijavu</router-link>
          </p>
          <p>
            © {{ new Date().getFullYear() }} Anytime Bigz
          </p>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
